import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cookieLib from '../../helpers/cookieLib';
import history from '../../utils/history';

class UserInfo extends Component {
  constructor(props) {
    super(props);
    this.flag = 1;
  }

  shouldComponentUpdate() {
    let callUserInfo = true;

    if (
      this.props &&
      this.props.userInfo &&
      Object.keys(this.props.userInfo).length
    ) {
      callUserInfo = false;
    }
    return callUserInfo;
  }

  componentDidUpdate() {
    const cid = cookieLib.getCookieByKey('cid');
    const token = cookieLib.getCookieByKey('token');
    const path = history.location.pathname;
    if (
      !this.props.userInfo &&
      cid &&
      token &&
      this.flag &&
      path.search('signup') === -1
    ) {
      this.flag = 0;
      this.props.getuserinfo();
      this.props.getWalletLimit();
    }
  }

  componentDidMount() {
    const cid = cookieLib.getCookieByKey('cid');
    const token = cookieLib.getCookieByKey('token');
    const path = history.location.pathname;
    if (
      !this.props.userInfo &&
      cid &&
      token &&
      this.flag &&
      path.search('signup') === -1
    ) {
      this.flag = 0;
      this.props.getWalletLimit();
      this.props.getuserinfo();
    }
    window.addEventListener(
      'storage',
      this.manageChangeInLocalstorage.bind(this),
      false,
    );
  }

  manageChangeInLocalstorage(event) {
    // document.hasFocus() - To avoid listening in the same tab
    if (!document.hasFocus()) {
      if (event.key === 'hasLogin') {
        if (!event.newValue) {
          window.localStorage.removeItem('hasLogin');
          // history.push("/logout");
          this.props.logout({});
        }
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('storage', this.manageChangeInLocalstorage);
  }

  render() {
    return '';
  }
}

UserInfo.propTypes = {
  userInfo: PropTypes.object,
  getuserinfo: PropTypes.func,
  logout: PropTypes.func,
};

export default UserInfo;
